import React from "react";
import { Form, Button, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { MoveLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import "./SocialListingAgent.scss";
import StyledTextInput from "src/components/reusable/StyledTextInput";

const BrandAnalysisForm: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    navigate("/account/social-listing-agent/loader", {
      state: {
        analysisType: "brand_analysis",
        brand: {
          brandName: values.brandName,
          instagram: values.instagram || "",
          facebook: values.facebook || "",
          tiktok: values.tiktok || "",
          redditSubreddits: values.redditSubreddits || "",
        },
      },
    });
    form.resetFields();
  };

  return (
    <div className="brand-form-container">
      <div className="brand-form-header">
        <Button onClick={() => navigate(-1)} className="competitive-back-button">
          <MoveLeft className="Brand-back-button" />
          {t("socialListingAgent.brandForm.back")}
        </Button>
      </div>

      <h1 className="brand-form-title">{t("socialListingAgent.brandForm.title")}</h1>
      <p className="brand-form-subtitle">{t("socialListingAgent.brandForm.subtitle")}</p>

      <Card className="brand-form-card">
        <Form layout="vertical" onFinish={onFinish} form={form}>
          <Form.Item
            label={t("socialListingAgent.brandForm.brandNameLabel")}
            name="brandName"
            className="brand-form-label"
            rules={[
              {
                required: true,
                message: t("socialListingAgent.brandForm.brandNameRequired"),
              },
            ]}
          >
            <StyledTextInput
              placeholder={t("socialListingAgent.brandForm.brandNamePlaceholder")}
              className="brand-placeholder"
            />
          </Form.Item>

          <Form.Item
            label={t("socialListingAgent.brandForm.instagramHandleLabel")}
            name="instagram"
            className="brand-form-label"
          >
            <StyledTextInput placeholder="@yourbrand" className="brand-placeholder" />
          </Form.Item>

          <Form.Item
            label={t("socialListingAgent.brandForm.facebookPageIdLabel")}
            name="facebook"
            className="brand-form-label"
          >
            <StyledTextInput
              placeholder={t("socialListingAgent.brandForm.facebookPageIdPlaceholder")}
              className="brand-placeholder"
            />
          </Form.Item>

          <Form.Item
            label={t("socialListingAgent.brandForm.tiktokUsernameLabel")}
            name="tiktok"
            className="brand-form-label"
          >
            <StyledTextInput placeholder="@yourbrand" className="brand-placeholder" />
          </Form.Item>

          <Form.Item
            label={t("socialListingAgent.brandForm.redditSubredditsLabel")}
            name="redditSubreddits"
            className="brand-form-label"
          >
            <StyledTextInput
              placeholder={t("socialListingAgent.brandForm.redditSubredditsPlaceholder")}
              className="brand-placeholder"
            />
          </Form.Item>

          <div className="brand-form-buttons">
            <Button type="primary" htmlType="submit" className="button button--primary">
              {t("socialListingAgent.brandForm.startAnalysis")}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default BrandAnalysisForm;
